export default {
    lang: {
        'vi-vn': 'Tiếng Việt',
        'zh-cn': '中文'
    },
    link: {
        'share': '分享',
        'pay': '支付',
        'tip': '打赏',
    },
    page: {
        home: '久久插一插',
        member: '会员中心',
        play: '播放器',
        login: '登录',
        register: '注册帐号',
        order: '订单',
        revision: '修订',
        guide: '指导',
        serve: '服务',
        companyProfile: '公司介绍',
        onlineService: '在线服务',
        financialDetails: '财务详情',
        recharge: '充值',
        withdraw: '提款',
        accountsCanBeReceived: '可以收到帐号',
        password: '登录密码',
        passwordFund: '提现密码',
        SubmitOrder: '提交订单',
        product: '提交订单',
        OrderDetail: '订单详情',
        out: '退出',
        PublishArticle: '发布文章',
        PublishVideo: '发布视频',
        inviteLink: '推广链接',
        treasurePlate: '聚宝盘计划',
        live: '直播',
    },
    side: {
        main: '首页',
        trade: '交易管理',
        tradeOrder: '订单列表',
        tradeRecharge: '充值管理',
        tradeWithdraw: '提现管理',
        tradeControl: '交易控制',
        tradeAmount: '金额调整',
        tradeStatistics: '统计报表',
        tradeReport: '代理报表',
        tradeReportDaily: '代理日报表',
        tradeReportMonthly: '代理月报表',
        commodity: '商品管理',
        commodityList: '商品列表',
        commoditySort: '商品分类',
        member: '会员管理',
        memberList: '会员列表',
        memberSort: '会员等级',
        memberLevel: '会中层级',
        content: '内容管理',
        contentNotice: '公告管理',
        contentText: '文本管理',
        contentAd: '首页轮播图',
        contentLogo: 'LOGO',
        power: '权限管理',
        powerList: '访问权限',
        powerAdmin: '系统用户',
        system: '系统管理',
        systemMenu: '系统菜单管理',
        systemParameter: '系统参数配置',
        systemLog: '系统操作日志'
    },
    but: {
        login: '登录',
        register: '注册',
        continue: '继续',
        recharge: '充值',
        withdraw: '提款',
        copy: '复制',
        copied: '已复制',
        downloadQr: '下载二维码',
        buyNow: '立即开通',
        close: '关闭',
        upload: '选择图片',
        reupload: '重新选择',
        uploading: '上传中...',
        save: '保存',
    },
    footer: {
        homePage: '主页',
        product: '产品',
        TreasurePlate: '聚宝盘',
        mine: '我的',
    },
    title: {
        account: '帐号',
        password: '密码',
        confirmPassword: '确认密码',
        inviteCode: '邀请代码',
        FundPassword: '资金密码',
    },
    placeholder: {
        account: '帐号',
        password: '请输入您的密码',
        agree: '我同意',
        userAgreement: '用户协议',
        user: '给您的帐号取个名字',
        confirmPassword: '请重新输入您的密码',
        invitation: '输入邀请码',
        rechargeAmount: '输入充值金额',
        withdrawalAmount: '输入提款金额',
        FundPassword: '输入资金密码 (VND)',
        firstSettingFund: '第一次设置可以不填',
    },
    text: {
        ShareGuys: '分享给好友',
        liveModeLowLatency: '低延迟',
        liveModeStable: '稳定模式',
        liveFlvUnsupported: '当前浏览器不支持 FLV，请改用低延迟或换 Chrome / Edge',
        liveFlvError: '稳定模式拉流失败，可切回低延迟或稍后重试',
        liveTapToPlay: '点一下画面即可播放',
        liveTapForSound: '点击开启声音',
        MySubordinates: '我的部下',
        MyTeam: '我的团队',
        totalAccountCount: '帐号总数',
        registerTime: '注册时间',
        noReferralMembers: '暂无注册帐号',
        noMore: '没有更多了',
        subordinatesDesc: '通过您的邀请链接直接注册的帐号',
        teamDesc: '经由您的邀请链注册的所有帐号（含多层级下级）',
        TodayOrder: '今天订单',
        TodayCommission: '今天佣金',
        MonthDirectRecharge: '本月充值',
        MonthDirectCommission: '本月佣金',
        monthDirectRechargeDesc: '本月直属帐号充值明细',
        noMonthDirectRecharge: '本月暂无直属充值记录',
        estimatedCommission: '预计佣金',
        loading: '加载中...',
        MonthTeamRecharge: '本月团队充值',
        MonthTeamCommission: '本月团队分润',
        MonthCommission: '本月团队佣金',


        VerificationCode: '手机验证码',
        workingCapital: '营运资金',
        quickAction: '快速操作',
        amountOfWorkingCapital: '营运资金金额',
        currentFrozenBalance: '当前冻结余额',
        orderToday: '今天订购',
        roseToday: '今天玫瑰',
        allOrders: '所有订单',
        totalCommission: '佣金总额',
        order: '订单',
        revision: '收款帐号',
        guide: '聚宝盘介绍',
        serve: '服务',
        companyProfile: '公司介绍',
        onlineService: '在线服务',
        financialDetails: '财务详情',
        receiveQrTip: '请上传您的支付宝与微信收款码，保存后供平台业务使用',
        uploadAlipayQr: '点击上传支付宝收款码',
        uploadWxQr: '点击上传微信收款码',
        receiveQrEmpty: '请先选择要上传的收款码',
        receiveQrTypeError: '仅支持 jpg/png/gif/webp 图片',
        receiveQrSizeError: '图片不能超过 2MB',
        rechargeAnnouncement: '注意：由于存款信息金额太大，存款前请务必仔细核对您的账户卡号。 该平台会不时更改帐号。 如有任何疑问，请点击在线客服！',
        rechargeLimit: '网上存款1（5万至3亿）',
        depositMethodSelect: '选择存款方式',
        depositMethod: '存款方式',
        serveText: '恭喜您，您已成功登录！',
        tipRecharge: '请在15分钟内完成银行转帐',
        AccountBalance: '账户余额',
        withdrawalMin: '最低提款金额：1',
        withdrawalMax: '最大提款金额以可用余额为准',
        withdrawMethod: '提款方式',
        withdrawTrx: 'TRX',
        withdrawUsdt: 'USDT',
        withdrawAvailable: '可提金额',
        withdrawTip: '提现手续费 5%，24 小时内到帐。',
        withdrawSelectType: '请选择提款方式',
        withdrawAmountInvalid: '请输入有效的提款金额，最低提款金额为 100 元。',
        withdrawBalanceNotEnough: '余额不足',
        withdrawRecord: '提现明细',
        withdrawRecordTotal: '提现记录数',
        withdrawApplyTime: '申请时间',
        withdrawMonth: '所属月份',
        withdrawStatusPending: '待付款',
        withdrawStatusSuccess: '成功',
        withdrawStatusFail: '失败',
        noWithdrawRecords: '暂无提现记录',
        rechargeRecord: '充值明细',
        rechargeRecordTotal: '充值记录数',
        rechargeApplyTime: '下单时间',
        rechargeOrderNo: '订单号',
        rechargeStatusWait: '等待',
        rechargeStatusCancel: '已取消',
        rechargeStatusPending: '待付款',
        rechargeStatusPaid: '已付款',
        rechargeStatusDone: '已完成',
        noRechargeRecords: '暂无充值记录',
        redEnvelopeTotal: '红包记录数',
        redEnvelopeGrantTime: '发放时间',
        redEnvelopeClaimTime: '领取时间',
        redEnvelopeUnclaimed: '未领取',
        redEnvelopeOpen: '打开红包',
        redEnvelopeScratchHint: '奖金待揭晓',
        redEnvelopePrize: '奖金金额',
        redEnvelopeClaimed: '已领取',
        noRedEnvelopeRecords: '暂无红包记录',
        WaitingForAllocation: '等待系统分配',
        amount: '金额',
        coin: '槟榔',
        loginTip: '我已经有帐号，现在去',
        regTip: '还没有帐号，现在去注册',
        videoList: '视频列表',
        goRecharge: '去充值',
        inviteLinkTip: '分享下方链接或二维码，邀请好友注册并成为您的下级',
        inviteRegisterLink: '邀请注册链接',
        inviteCodeTip: '邀请码即您的帐号 UUID，好友可通过上方链接自动带入或手动填写',
        inviteFromLink: '您正在通过推广链接注册，邀请码已自动填入',
        copySuccess: '链接已复制到剪贴板',
        copyFailed: '复制失败，请手动复制',
        servicePlan: '服务套餐',
        monthlyPlan: '包月服务',
        quarterlyPlan: '包季服务',
        halfYearPlan: '半年服务',
        yearPlan: '包年服务',
        monthlyDays: '有效期 31 天，可叠加',
        quarterlyDays: '有效期 93 天（3 个月），可叠加',
        halfYearDays: '有效期 186 天（6 个月），可叠加',
        yearDays: '有效期 365 天（12 个月），可叠加',
        planDaysFallback: '有效期 {days} 天，可叠加',
        currentValidUntil: '当前有效期至',
        notActivated: '尚未开通',
        serviceActive: '服务生效中',
        serviceExpired: '已过期',
        rmb: '人民币',
        buying: '开通中…',
        buySuccess: '开通成功',
        subscribeTip: '开通成功后，时长自动叠加。',
        payMethod: '支付方式',
        payAlipay: '支付宝',
        payWxpay: '微信支付',
        payRedirecting: '正在跳转支付…',
        payCreateFailed: '创建支付订单失败，请稍后重试',
        payPendingTip: '若已完成支付，有效期将在片刻内自动更新；如未变化请刷新页面。',
        payScanWxTip: '请使用微信扫描下方二维码完成支付',
        payScanAlipayTip: '请使用支付宝扫描下方二维码完成支付',
        payWaiting: '等待支付结果…',
    },
    treasurePlate: {
        becomeTitle: '如何成为代理',
        becomeDesc: '成为代理，只需要购买一个全年套餐即可。在这一年的周期里，你可以享受代理权益，获得收益。',
        benefitTitle: '代理收益说明',
        benefitDesc: '代理收益分为两部分：A 充值分佣、B 平台红包。',
        directTitle: 'A · 充值分佣',
        directTip: '成为代理后，通过分享视频给好友，好友注册并购买套餐后，你获得收益。按直属下级月充值金额对应返佣等级：',
        teamTitle: 'B · 平台红包',
        teamIntro: '平台红包，是平台对代理的奖励，终生有效。',
        colRank: '级别',
        colAmount: '充值金额',
        colSlogan: '口号',
        goBuyYear: '立即购买包年套餐',
        r1: { title: '战士', amount: '≤ 2k', slogan: '单兵作战，小试牛刀' },
        r2: { title: '班长', amount: '> 2k 且 ≤ 3k', slogan: '带班攻坚，初显锋芒' },
        r3: { title: '排长', amount: '> 3k 且 ≤ 4k', slogan: '步入军官，自立门户' },
        r4: { title: '连长', amount: '> 4k 且 ≤ 5k', slogan: '中流砥柱，中层骨干' },
        r5: { title: '营长', amount: '> 5k 且 ≤ 6k', slogan: '营级指挥，兵强马壮' },
        r6: { title: '团长', amount: '> 6k 且 ≤ 7k', slogan: '独当一面，一方诸侯' },
        r7: { title: '旅长', amount: '> 7k 且 ≤ 8k', slogan: '纵横沙场，稳坐中军' },
        r8: { title: '师长', amount: '> 8k 且 ≤ 9k', slogan: '封疆大吏，诸侯霸主' },
        r9: { title: '军长', amount: '> 9k 且 ≤ 10k', slogan: '统领集团，功勋卓越' },
        r10: { title: '司令', amount: '> 10k', slogan: '终极统帅，傲视群雄' },
        t1: '当平台有一个帐号完成充值时，平台将充值金额的 2% 做为团队红包发放；',
        t2: '按 2% 的 0.25 做为红包，逐级发给所有上级；',
    },
    guideText: {
        no1: '- 网上购物带来便捷、主动、多样的选择，采购、销售、安全支付、专业配送的支持服务，Pinggo.vn 不断努力和改进，以满足消费者的购物需求。',
        no2: '- PingGo 的产品保证来自供应商和品牌的正品，价格具有竞争力。 在PingGo订购时，您无需担心质量，因为本场出售的产品都是经过 PingGo 精心挑选和检查的。',
        no3: '- 我们每周服务 7 天。',
        no4: '- 工作规定：',
        no5: '- 工作时，成员必须遵守秩序，遵守制度的规定和要求。',
        no6: '- Pinggo.vn 衷心感谢为陪伴 Pinggo 股份公司做出贡献的会员。',
    },
    revision: {
        password:'密码',
        withdrawalPassword: '提现密码',
        withdrawalAccount: '提款账户',
        currentPassword: '当前密码',
        aNewPassword: '新密码',
        confirmYourPassword: '确认你的密码',
        realName: '真正的名字',
        userNAME: '用户名',
        bankAccount: '银行账户',
        bankName: '银行名',
        rechargeAmount: '充值金额',
        CompleteRecharge: '完成充值',
        withdrawalAmount: '提款金额',
    },
    order: {
        all: '所有的',
        not: '未解决',
        complete: '完全的',
        frozen: '冷冻的',
    },
    input: {
        Account: '用户名',
        Passkey: '密码',
        real_name: '真实姓名',
        bank_user: '用户名',
        bank_card: '银行账户',
        bank_id: '银行名',
        amount: '提现金额（最低提款金额为 100 元）',
        pass_pay: '资金密码',
        pass_login: '当前密码',
        new: '新密码',
        confirm: '确认密码',
    },
    pageTxt: {
        order: {
            tab1: '全部',
            tab2: '等待',
            tab3: '完成',
            tab4: '冻结',
            awaiting: '等待分配',
        },
        orderDetail: {
            orderValue : '订单价值',
            profitMoney: '佣金',
            amountToBeReturned: '要退回的金额',
            codeOrders: '编号',
            receivingTime: '时间',
            orderStatus: '订单状态',
            submit: '付款',
        }
    }
}